import store from '@/store'
import { ref, computed } from '@vue/composition-api'
import { isNavLinkActive, navLinkProps } from '@core/layouts/utils'

export default function useVerticalNavMenuLink(item) {
  const isActive = ref(false)

  const linkProps = navLinkProps(item)

  const updateIsActive = () => {
    const state = isNavLinkActive(item);
    isActive.value = state
  }

  const navTagStore = computed({
    get: () => store.state.verticalMenu.tags,
  })

  return {
    isActive,
    linkProps,
    navTagStore,
    updateIsActive,
  }
}
